import styled from 'styled-components'
import { theme } from '../../../../../style/theme'
import { colorTheme } from '../../../../../style/theme/colorTheme'

export const MarkReadyStatusRow = styled.div`
	font-size: 1.13em;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5em;
	font-family: ${theme.fontRobotoMedium};
	padding: 0 0.2em;
	color: ${colorTheme.modal.buttons.markReady.pending.text};

	&.success {
		color: ${colorTheme.modal.buttons.markReady.success.text};
	}

	&.error {
		color: ${colorTheme.modal.buttons.markReady.error.text};
	}

	> svg {
		width: 1.28em;
		height: 1.28em;
		flex-shrink: 0;
		fill: currentColor;
	}
`
MarkReadyStatusRow.displayName = 'MarkReadyStatusRow'

export const MarkReadyDots = styled.span`
	font-size: 1rem;
	display: inline-flex;
	align-items: center;
	gap: 0.25em;

	span {
		width: 0.875em;
		height: 0.875em;
		flex-shrink: 0;
		border-radius: 50%;
		background: ${colorTheme.modal.buttons.markReady.pending.border};
		transform: scale(0.43); /* 6px of 14px */
		animation: mark-ready-dot-animation 1s infinite ease-in-out;

		&:nth-child(1) {
			animation-delay: 0s;
		}

		&:nth-child(2) {
			animation-delay: 0.2s;
		}

		&:nth-child(3) {
			animation-delay: 0.4s;
		}
	}

	@keyframes mark-ready-dot-animation {
		0% {
			transform: scale(0.43); /* 6px */
		}

		20% {
			transform: scale(0.57); /* 8px */
		}

		40% {
			transform: scale(1); /* 14px */
		}

		60%, 100% {
			transform: scale(0.43); /* 6px */
		}
	}
`
MarkReadyDots.displayName = 'MarkReadyDots'

export const MarkReadyButtonWrap = styled.div`
	font-size: 1rem;

	&.pending, &.succeeded, &.error  {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		padding: 0.31em 0.31em 0;
		border-radius: 0.94em;
		border-width: 1px;
		border-style: solid;
		background-color: ${colorTheme.modal.buttons.markReady.background};
		margin-bottom: 0.46em;
	}

	&.pending {
		border-color: ${colorTheme.modal.buttons.markReady.pending.border};
	}

	&.succeeded {
		border-color: ${colorTheme.modal.buttons.markReady.success.text};
	}

	&.error {
		border-color: ${colorTheme.modal.buttons.markReady.error.border};
	}
`
MarkReadyButtonWrap.displayName = 'MarkReadyButtonWrap'
